/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ScreenerResident } from './ScreenerResident';
import {
    ScreenerResidentFromJSON,
    ScreenerResidentFromJSONTyped,
    ScreenerResidentToJSON,
    ScreenerResidentToJSONTyped,
} from './ScreenerResident';

/**
 * 
 * @export
 * @interface Occupancy
 */
export interface Occupancy {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    resident: ScreenerResident;
    /**
     * 
     */
    type: OccupancyTypeEnum;
    /**
     * 
     */
    start_date: Date;
    /**
     * 
     */
    end_date?: Date;
}


/**
 * @export
 */
export const OccupancyTypeEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved In',
} as const;
export type OccupancyTypeEnum = typeof OccupancyTypeEnum[keyof typeof OccupancyTypeEnum];


/**
 * Check if a given object implements the Occupancy interface.
 */
export function instanceOfOccupancy(value: object): value is Occupancy {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('resident' in value) || value['resident'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('start_date' in value) || value['start_date'] === undefined) return false;
    return true;
}

export function OccupancyFromJSON(json: any): Occupancy {
    return OccupancyFromJSONTyped(json, false);
}

export function OccupancyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Occupancy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resident': ScreenerResidentFromJSON(json['resident']),
        'type': json['type'],
        'start_date': (json['start_date'] == null ? json['start_date'] : parseDate(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (parseDate(json['end_date'])),
    };
}

export function OccupancyToJSON(json: any): Occupancy {
    return OccupancyToJSONTyped(json, false);
}

export function OccupancyToJSONTyped(value?: Occupancy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'resident': ScreenerResidentToJSON(value['resident']),
        'type': value['type'],
        'start_date': value['start_date'] == null ? value['start_date'] : serializeDate(value['start_date']),
        'end_date': value['end_date'] == null ? value['end_date'] : serializeDate(value['end_date']),
    };
}

